import RepsolLayoutComponent from './RepsolLayoutComponent.vue';
import { operacionesRoutes } from '@/modules/operaciones/routes';
import { cierresRoutes } from '@/modules/cierres/routes';
import { alertasRoutes } from '@/modules/alertas/routes';
import { administracionRoutes } from '@/modules/administracion/routes';
import { helpRoutes } from '@/views/help/help.routes';
import { emptyRoutes } from '@/views/empty/empty.routes';

// Need to change the views
export const layoutRoutes = {
  path: '',
  name: 'Layout',
  component: RepsolLayoutComponent,
  meta: {
    title: '',
    isPublic: false,
  },
  children: [
    cierresRoutes,
    alertasRoutes,
    operacionesRoutes,
    administracionRoutes,
    helpRoutes,
    emptyRoutes,
  ],
};
